import React from 'react'
import { NextPage } from 'next'

import { StandardLayout } from 'shared/layout/StandardLayout'
import { ExplorePageProps } from 'types/page'
import { ContentfulProducts, ROUTES } from 'parameters/index'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import PersonalLoansPage from 'experiences/products/PersonalLoansPage'
import { ProductConstraint } from 'services/ContentfulService/constraints'

// This page is still being used by direct link from emails
// https://engine-by-ml.atlassian.net/jira/software/c/projects/CX/issues/CX-908
const PersonalLoans: NextPage<PagePropsWrapper<ExplorePageProps>> = ({ metaTags, pageProps }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<PersonalLoansPage articles={pageProps.articles} />
	</StandardLayout>
)

PersonalLoans.getInitialProps = explorePageInitialProps(
	ROUTES.PERSONAL_LOANS,
	ProductConstraint(ContentfulProducts.Loans)
)

export default PersonalLoans
